import { render, staticRenderFns } from "./Negocio.vue?vue&type=template&id=599a9a28"
import script from "./Negocio.vue?vue&type=script&lang=js"
export * from "./Negocio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports